export default "__VITE_ASSET__DbubYwO9__"